import type { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export const DottedAngleLineIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} width="15" height="33" viewBox="0 0 15 33" fill="none">
    <path d="M1 0.5V32.5H15" stroke="#6D7B99" fill="none" strokeDasharray="2 2" />
  </SvgIcon>
);
